import React from 'react'
import { Children } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

function NotAuthed({children}) {
    const isLoggedIn =useSelector(state=>state.GlobalReducer?.token)
    const user =useSelector(state=>state.GlobalReducer?.user)
    if(user?.user_type=='user' &&isLoggedIn){
      return <Navigate to='/guest/personal-information'/>
    }
    if(isLoggedIn){
      return <Navigate to='/'/>
    }
    
    return children
}

export default NotAuthed